export const DELIVERY_CHANNEL_OPTIONS = {
  DELIVERY: "delivery",
  PICKUP: "pickup-in-point",
  FULL: "full"
};

export const DELIVERY_OPTIONS = {
  SCHEDULED: "Entrega agendada",
  SHIP_FROM_STORE: "Cobasi Já",
  EXPRESS: "Expressa",
  ECONOMIC1: "Econômica1",
  ECONOMIC2: "Econômica2",
  PICKUP: "Retira"
};

export const PICKUP_TIME = {
  DEFAULT: "45 minutos",
  OTHERS: "1 dia útil"
};

export const PICKUP_CONFIGS = {
  DISCOUNT: 5,
  PRICE_MIN_DISCOUNT: 149,
  PRICE_MIN_FRETE_GRATIS: 149
};
